import { statusColor } from '../lib/status.js';

export function StatusPill({ status }: { status: string }) {
  return (
    <span className={`pill pill-${statusColor(status)}`} data-testid="status-pill">
      {status}
    </span>
  );
}
